import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {ImportModel} from '@/libs/Api';
import {ImportsDataService} from '@/libs/imports/imports-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const importsStore = registerCrudStore<ImportModel, ImportModel>(BusinessModule.Import, new ImportsDataService());
